import { render, staticRenderFns } from "./menuBox.vue?vue&type=template&id=79c5871e&scoped=true"
import script from "./menuBox.vue?vue&type=script&lang=js"
export * from "./menuBox.vue?vue&type=script&lang=js"
import style0 from "./menuBox.vue?vue&type=style&index=0&id=79c5871e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5871e",
  null
  
)

export default component.exports